// Punto único de entrada a GSAP para la librería.
// gsap es peerDependency y se externaliza en el build; los componentes nunca lo
// importan directamente, solo a través de getGsap() (que además es SSR-safe).
import { gsap } from 'gsap'

/** Duraciones y curvas centralizadas para mantener consistencia entre componentes. */
export const MOTION = {
  enter: 0.18,
  exit: 0.16,
  ease: 'power2.out',
  easeOut: 'power3.out',
  sheet: { enter: 0.28, exit: 0.22, ease: 'power3.out' }
} as const

/** Devuelve gsap solo en navegador; null en SSR o entornos sin window. */
export function getGsap(): typeof gsap | null {
  if (typeof window === 'undefined') return null
  return gsap
}

/** true si el usuario pidió reducir el movimiento; los wrappers lo respetan. */
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
